export default __webpack_public_path__ + "static/media/cryptobckg.ebcf75b7.jpeg";